import { createStyles, rem } from '@mantine/core'

export default createStyles((theme, _params) => {
  return {}
})
